module.exports = __webpack_public_path__ + "img/ic_user.a090efd4.png";